import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LocationPageComponent } from './journey/location-page/location-page.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { ApplicationDetailsComponent } from './journey/application-details/application-details.component';
import { ChecklistComponent } from './journey/checklist/checklist.component';
import { TncsComponent } from './journey/tncs/tncs.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { SessionComponent } from './session/session.component';
import { PaymentComponent } from './journey/payment/payment/payment.component';

const routes: Routes = [
  { path: '', redirectTo: '/location', pathMatch: 'full' },
  { path: 'location', component: LocationPageComponent, data: { breadcrumb: 'Location | Láthair' }},
  { path: 'booking-details', component: BookingDetailsComponent, data: { breadcrumb: 'Booking Details | Sonraí na hÁirithinte' }},
  { path: 'application-details', component: ApplicationDetailsComponent, data: { breadcrumb: 'Appointment Details | Sonraí na Coinne' }},
  { path: 'checklist', component: ChecklistComponent, data: { breadcrumb: 'Checklist | Seicliosta' } },
  { path: 'terms-conditions', component: TncsComponent, data: { breadcrumb: 'T&Cs | Téarmaí & Coinníollacha' } },
  { path: 'payment', component: PaymentComponent, data: { breadcrumb: 'Payment | Íocaíocht' } },
  { path: 'confirmation', component: ConfirmationComponent, data: { breadcrumb: 'Confirmation | Deimhniú' } },
  { path: 'sessionExpired', component: SessionComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
